import { useState } from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { ConfirmModalShell } from '../../work-queue/tasks/approval-review/ConfirmModalShell';
import { ConfirmModalHeader } from '../../work-queue/tasks/approval-review/ConfirmModalHeader';
import { ConfirmModalFooter } from '../../work-queue/tasks/approval-review/ConfirmModalFooter';

interface ResolveActivationNotificationModalProps {
    submitting: boolean;
    onConfirm: (sendActivation: boolean) => void;
    onClose: () => void;
}

export function ResolveActivationNotificationModal({
    submitting,
    onConfirm,
    onClose
}: ResolveActivationNotificationModalProps) {
    const [sendActivation, setSendActivation] = useState(false);

    return (
        <ConfirmModalShell widthClassName="w-[440px]" dismissible={!submitting} onDismiss={onClose}>
            <ConfirmModalHeader
                icon={EnvelopeIcon}
                iconClassName="w-5 h-5 text-gray-700"
                title="Resolve notification"
                onClose={onClose}
                disabled={submitting}
            />
            <div className="px-5 py-4 flex flex-col gap-3">
                <p className="text-sm text-gray-600">
                    The patient hasn&apos;t activated the Dental Monitoring app yet.
                </p>
                <label className="flex items-center gap-2.5 cursor-pointer">
                    <input
                        type="checkbox"
                        checked={sendActivation}
                        onChange={(e) => setSendActivation(e.target.checked)}
                        disabled={submitting}
                        className="h-4 w-4 rounded border-gray-300 accent-gray-800 focus:ring-gray-500 shrink-0"
                    />
                    <span className="text-sm text-gray-700">Also send activation email</span>
                </label>
            </div>
            <ConfirmModalFooter
                onCancel={onClose}
                onConfirm={() => onConfirm(sendActivation)}
                cancelDisabled={submitting}
                confirmDisabled={submitting}
                confirmLabel={submitting ? 'Resolving…' : 'Resolve'}
                confirmColorClassName="bg-gray-800 text-white hover:bg-gray-900"
            />
        </ConfirmModalShell>
    );
}
